import { formatter } from "./formatter";

export const promotion = {
	defaultName: "Copy of {{promotion}}",
	errors: {
		nameLength: "The promotion name has not reached the minimum number of characters.",
		sameName: "The copy name is the same as the original name.",
		notFilledCorrectly: "The fields were not filled in correctly.",
	},

	copyModal: {
		okText: "Copy",
		title: "Create promotion copy",
		message: "Do you want to create a copy of the promotion",
		placeholder: "Promo copy name",
	},
	peopleTable: {
		example: "example worksheet",
		error: "Invalid format",
		import: "Import Sheet",
		download: "Download sample worksheet",
	},
	categoryModal: {
		title: "Add New Product",
		suggestedTitle: "Add suggested product",
		mainTitle: "Add the main product",
		label: "Product or category",
		placeholder: "Search for a product or category",
		searchPlaceholder: "Search by product",
		selectAll: "Select all products",
		categoriesTitle: "Categories",
		allCategories: "All categories ({{count}})",
		selectedCount: "{{count}} products selected",
		confirm: "Add product",
		noneProduct: "No products found",
	},
	creationStep: {
		formatter,
		error: "Unable to redirect page.",
		steps: {
			promotionInfo: "Promotion Data",
			goals: "Goals",
			awards: "Awards",
			usageConditions: "Conditions of Use",
			resume: "Summary",
		},
		stepsPages: {
			goals: {
				tableWarningMessage: "Information not available for Tables.",
				label: "Recurrence of earnings",
				placeholder: "Select a maximum recurrence of earnings",
				error: "Condition ALL CLIENTS needs to be removed",
				new: "New goal",
				add: "Add goal",
				goalTypeTitle: "Select the goal type",
				fichaCombineInfo:
					"To combine Ticket promotion types in the same event, create separate promotions",
				frequencyInfo:
					"Sets how often the identified customer can earn the promotion.",
				cashlessNoGoalWarning:
					"If you do not add any goal, the promotion must be actively granted in the list of benefited CPFs after the promotion is created.",
				everybodyExclusiveTooltip:
					"When selected, the promotion cannot have another associated goal.",
				goalUnavailableMesas: "Goal not available for table-type operations",
				checkinLabel: "Set the arrival time",
				minimumRechargePlaceholder: "Set the minimum recharge amount",
				birthdayOptions: {
					month: "Month",
					week: "Week",
					day: "Day",
				},
				genderOptions: {
					Female: "Woman",
					Male: "Man",
					Other: "Other",
				},
				buyAndEarn: {
					minQuantityLabel: "Minimum consumption quantity",
					minQuantityInfo:
						"Set how many products the customer must buy to earn the promotion.",
					productLabel: "Add the promotion product",
					productInfo: "Select the products included in the promotion.",
					addProducts: "add products",
				},
				conditions: {
					birthday: {
						month: "Birthday of the month",
						week: "Birthday boy of the week",
						day: "Birthday Boy",
					},
					checkin: {
						label: "Arrival time",
					},
					gender: {
						male: "Men",
						female: "Women",
						others: "Others",
					},
					minimumRecharge: {
						label: "Minimum recharge amount",
					},
				},
			},
			usageConditions: {
				conditions: {
					expiration: {
						label: "Calendar days:",
						suffix: "Days",
					},
					period: {
						beginTime: "From",
						endTime: "Until",
						error: "Invalid time format for conversion",
					},
					week: {
						infoText:
							"As events can start on one day of the week and end on the other, the promotion is valid on the day the event starts. So the customer can use the promotion the next day if the event started the day before.",
						validPromotion: "Valid Promotion",
					},
					modal: {
						new: "New usage condition",
						add: "Add usage condition",
					},
				},
				totem: {
					usageLimitTitle: "Usage limit",
					usageLimitDescription:
						"Set a maximum number of times the promotion can be used",
					usageLimitUnlimited: "Unlimited",
					usageLimitWithLimit: "With limit",
					usageLimitPlaceholder: "Set the usage limit",
					usageLimitAlertTitle: "Internet connection dependency",
					usageLimitAlertMessage:
						"By setting a usage limit, this promotion will depend on an internet connection at the POS. Unlimited promotions work offline.",
					usageLimitOfflineTitle: "Works offline",
					usageLimitOfflineMessage:
						"Without a usage limit, this promotion will work normally even without an internet connection.",
					expirationTitle: "Post-earning expiration (optional)",
					expirationDescription:
						"Set how long the customer will have to enjoy the promotion",
					expirationPlaceholder: "Set the expiration time in calendar days",
					importantTitle: "Important",
					importantBuyAndEarn:
						"The usage conditions for 'Buy and Earn' are also used to earn the promotion.",
					importantExpiration:
						"Post-earning expiration does not apply to 'Buy and Earn'.",
					weekDaysTitle: "Days of the week",
					weekDaysDescription:
						"Set which days of the week the customer can use the promotion.",
					periodTitle: "Days and time of use",
					periodDescription:
						"Set the time range and/or days of the week when customers can use the promotion",
				},
			},
		},
		stepsWrapper: {
			title: "Title not found",
			description: "Description not found",
			save: "Save changes",
			saveAndPublish: "Save and publish",
			discard: "Discard changes",
		},
	},
	table: {
		goals: {
			label: "Promotion target list",
			empty: "No goal",
			new: "New goal",
		},
		usageConditions: {
			label: "List of conditions of use of the promotion",
			empty: "No usage conditions",
			new: "New usage condition",
		},
	},
};
